import type { ID } from '@/model/Common.model';
import type { MainUser } from '@/model/User.model';

export const mapFormDataToAssignees = (formData: { assignees: Array<ID> }) => ({
  users: formData.assignees,
});

export const isActive = (user: MainUser) => user.pivot.status === 'active';
